import { Col, List } from 'antd';
import Card from 'app/components/Card';
import { Paragraph } from 'app/components/Typography/Paragraph';
import React from 'react';
import { DescriptionFields } from './constants';
import get from 'lodash/get';
import styled from '@emotion/styled';
import StyledInfo from '../StyledInfo';
import ProductItem from 'app/pages/TemplateManagment/components/ProductItem';
import { ListProduct } from './ListProducts';
type Props = {
  // data: {};
  factory: any;
  suppliers: Array<any>;
  inspectionId: string;
};
const StyledCard = styled(Card)`
  height: 100%;
  background: #fff;
  overflow: auto;
  padding-bottom: 16px;
`;

const StyledProductItem = styled(ProductItem)`
  .wrapperDescription {
    width: 100%;
    > div:nth-of-type(3) {
      > div {
        width: 100%;
        > div {
          &:last-of-type {
            width: 90%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
  }
`;

const OtherDescription = ({ factory, suppliers, inspectionId }: Props) => {
  const [currentTab, setCurrentTab] = React.useState('factory');

  const Tabs = [
    { key: 'factory', tab: 'Factory' },
    { key: 'supplier', tab: 'Supplier' },
    { key: 'product', tab: 'Product' }
  ];
  const Fields = React.useMemo(() => {
    return get(DescriptionFields, currentTab, []) as any[];
  }, [currentTab]);

  const data = React.useMemo(() => {
    if (currentTab === 'factory') return factory;
    if (currentTab === 'supplier') return suppliers;
    return [];
  }, [factory, suppliers, currentTab]);

  return (
    <StyledCard bordered={false} tabList={Tabs} onTabChange={setCurrentTab}>
      {currentTab === 'product' ? (
        <ListProduct inspectionId={inspectionId} />
      ) : Array.isArray(data) ? (
        <List
          bordered={false}
          itemLayout="vertical"
          rowKey={(item) => item.id}
          dataSource={data}
          renderItem={(item, index) => {
            if (currentTab === 'product') {
              return (
                <StyledProductItem
                  buttonProps={{ hidden: true }}
                  order={index}
                  hiddenOrder
                  product={item}
                  linkageTemplate={item?.inspectionCriteria}
                ></StyledProductItem>
              );
            }
            return (
              <List.Item>
                {Fields.map(({ name, label, defaultValue, format }, index) => {
                  const value = get(item, name, defaultValue);
                  return (
                    <StyledInfo key={index}>
                      <Col span={12}>{label}</Col>
                      <Col span={12}>
                        <Paragraph>
                          {format ? format(value, item) : value}
                        </Paragraph>
                      </Col>
                    </StyledInfo>
                  );
                })}
              </List.Item>
            );
          }}
        ></List>
      ) : (
        Fields.map(({ name, label, defaultValue, format }, index) => {
          const value = get(data, name, defaultValue);
          return (
            <StyledInfo key={index}>
              <Col span={12}>{label}</Col>
              <Col span={12}>
                <Paragraph>{format ? format(value, data) : value}</Paragraph>
              </Col>
            </StyledInfo>
          );
        })
      )}
    </StyledCard>
  );
};

export default OtherDescription;
